import _ from 'lodash'
import { useState } from 'react'
import * as authApi from './auth-api'
import useCountDown from './use-count-down'
import { isErrorExist, convertResponseToErrorObject } from '../../omnitech-error'

function useSmsToken(defaultCountFrom = 60) {
  const [smsTokenDisable, updateSmsTokenDisable] = useState(false)
  const { count, startCounter, resetCounter } = useCountDown(defaultCountFrom, () => {
    updateSmsTokenDisable(false)
  })

  const getWhatsAppToken = async phone => {
    try {
      updateSmsTokenDisable(true)
      // TODO: tidy the result and return
      const result = await authApi.createWhatsappToken({ phone })
      startCounter()
      return result
    } catch (error) {
      updateSmsTokenDisable(false)
      const data = _.get(error, 'response.data', {})

      if (isErrorExist(data)) {
        const errorObject = convertResponseToErrorObject(data, {useResponseMessage: true})

        throw errorObject
      }

      throw error
    }
  }

  const sendSmsToken = async phone => {
    try {
      updateSmsTokenDisable(true)
      // TODO: tidy the result and return
      const result = await authApi.createSmsToken({ phone })
      startCounter()
      return result
    } catch (error) {
      updateSmsTokenDisable(false)
      const data = _.get(error, 'response.data', {})

      if (isErrorExist(data)) {
        const errorObject = convertResponseToErrorObject(data, {useResponseMessage: true})

        throw errorObject
      }

      throw error
    }
  }

  const resetCounterSmsToken = () => {
    resetCounter()
    updateSmsTokenDisable(false)
  }

  return {
    getWhatsAppToken,
    sendSmsToken,
    smsTokenCountDown: count,
    smsTokenDisable,
    resetCounterSmsToken
  }
}

export default useSmsToken
